<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="login_titleBox">
          <!-- <div class="login_logo hidden-sm-and-down"></div> -->
          <div class="text-center login_title">
            <img src="../assets/images/login_logo.png" />
            《{{ $store.state.Name }}》 —
            <span class="highorange">邮箱验证</span>
          </div>
        </div>
        <div class="Email_content">
          <p class="highgreen">{{ message }}</p>
          <!-- <p class="highred" v-else>{{message}}</p> -->
          <div style="margin: 20px">
            <el-button @click="$router.push('/')">返回首页</el-button>
            <el-button type="primary" style="width: auto" @click="close"
              >关闭页面</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      guid: '',
      message: '',
      isEmailT: true,
    }
  },

  async mounted() {
    if (this.$route.query.Guid) {
      this.guid = this.$route.query.Guid
      let carousel = await this.$store.dispatch('_EamilVerification', {
        guid: this.guid,
      })
      if (carousel.data.IsSuccess) {
        this.isEmailT = true
        this.message = carousel.data.Message
        this.$message({ message: '邮箱验证成功', type: 'success' })
      } else {
        this.isEmailT = false
        this.message = carousel.data.Message
        this.$message({ message: res.data.Message, type: 'error' })
      }
    } else {
      this.$message({ message: '网络错误，请稍后重试。', type: 'error' })
    }
  },

  methods: {
    close() {
      window.close()
    },
  },
}
</script>

<style scoped>
.eqcode {
  font-size: 16px;
}
.Email_content {
  text-align: center;
}
.highgreen {
  color: #4d994d;
  line-height: 25px;
}
.highred {
  color: #d9534f;
}
</style>
